module.exports = "pegasus/assets/blocks/column-7-theme3.png";